// extracted by mini-css-extract-plugin
module.exports = {"price_banner":"PriceBanner_price_banner__sH_aK","budget_btn":"PriceBanner_budget_btn__YERhS"};